module.exports = __webpack_public_path__ + "static/spider-web-0811dcd8a0ef4922856472630d989c27.png";